<template>
  <div class="settings-page p-4">
    <h2 class="mb-4">
      <Settings :size="24" class="me-2" />
      Company Settings
    </h2>

    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'general' }"
          href="#"
          @click.prevent="activeTab = 'general'"
        >
          <Building :size="18" class="me-1" />
          General
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'email' }"
          href="#"
          @click.prevent="activeTab = 'email'"
        >
          <Mail :size="18" class="me-1" />
          Email
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'sms' }"
          href="#"
          @click.prevent="activeTab = 'sms'"
        >
          <MessageSquare :size="18" class="me-1" />
          SMS
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'roles' }"
          href="#"
          @click.prevent="activeTab = 'roles'"
        >
          <Shield :size="18" class="me-1" />
          Roles
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'payments' }"
          href="#"
          @click.prevent="activeTab = 'payments'"
        >
          <CreditCard :size="18" class="me-1" />
          Payments
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link" 
          :class="{ active: activeTab === 'status' }"
          href="#"
          @click.prevent="activeTab = 'status'"
        >
          <Tag :size="18" class="me-1" />
          Status
        </a>
      </li>
    </ul>

    <div v-show="activeTab === 'general'">
      <general-settings-tab />
    </div>

    <div v-show="activeTab === 'email'">
      <email-settings-tab />
    </div>

    <div v-show="activeTab === 'sms'">
      <sms-settings-tab />
    </div>

    <div v-show="activeTab === 'roles'">
      <roles-settings-tab />
    </div>

    <div v-show="activeTab === 'payments'">
      <payments-settings-tab />
    </div>

    <div v-show="activeTab === 'status'">
      <status-settings-tab />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Settings, Building, Mail, MessageSquare, Shield, CreditCard, Tag } from 'lucide-vue-next';
import GeneralSettingsTab from '@/components/Settings/GeneralSettingsTab.vue';
import EmailSettingsTab from '@/components/Settings/EmailSettingsTab.vue';
import RolesSettingsTab from '@/components/Settings/RolesSettingsTab.vue';
import PaymentsSettingsTab from '@/components/Settings/PaymentsSettingsTab.vue';
import SmsSettingsTab from '@/components/Settings/SmsSettingsTab.vue';
import StatusSettingsTab from '@/components/Settings/StatusSettingsTab.vue';

const activeTab = ref('general');
</script>

<style scoped>
.settings-page {
  max-width: 1400px;
  margin: 0 auto;
}

.nav-tabs .nav-link {
  color: #495057;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0.75rem 1.5rem;
  transition: all 0.2s ease;
}

.nav-tabs .nav-link:hover {
  background-color: #f8f9fa;
  color: #132341;
  border-bottom-color: #132341;
}

.nav-tabs .nav-link.active {
  background-color: transparent;
  color: #132341;
  border-bottom-color: #132341;
  font-weight: 600;
}
</style>
